var portfolioHeader = {
	portfolioValue: "Valeur du portefeuille en {currency}",
	todayChange: "Changement aujourd'hui",
	unrealizedPerformance: "Perf. non réalisée",
	realizedProfits: "Profits réalisés",
	totalValue: "Valeur totale",
	purchaseValue: "Montant à l'achat",
	totalPerformance: "Performance globale",
	baseCurrency: "Devise de base",
	numberOfPositions: "Positions",
	lastCalculationDateTime: "Dernier calcul"
};
var fr = {
	portfolioHeader: portfolioHeader
};

export { fr as default, portfolioHeader };
